import React from 'react';
import withHeader from "../../hocs/withHeader";
import withFooter from "../../hocs/withFooter";
import SurveysTable from "./surveys_table/SurveysTable";
import ErrorBoundary from "../../meta/ErrorBoundary";

function SurveysPage(props) {
    return (
        <section className="surveys surveys--dark">
            <ErrorBoundary boundaryName="Surveys Page">
                <SurveysTable {...props}/>
            </ErrorBoundary>
        </section>
    )
}

export default withFooter(withHeader(SurveysPage));